import { alertConstants } from '../constant/alert-constant';

export const alertActions = {
    success,
    error,
    clear
};

function success(message, notiType = 'default') {
    return { type: alertConstants.SUCCESS, message, notiType };
}

function error(message, notiType = 'default') {
    return { type: alertConstants.ERROR, message, notiType };
}

function clear() {
    return { type: alertConstants.CLEAR };
}


// WEBPACK FOOTER //
// ./src/redux/actions/alert-actions.jsx